/* eslint-disable react/prop-types */
import { Alert, Snackbar } from "@mui/material";
import translations from "../translations/index";

export default function Notification({ openSnackbar, handleCloseSnackbar }) {
  const locale = window.authSettings ? window.authSettings.locale : "fr-FR";
  const translation = translations.getTranslations(locale);
  return (
    <Snackbar
      open={openSnackbar}
      autoHideDuration={6000}
      onClose={handleCloseSnackbar}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      //message="Note archived"
      sx={{
        width: "34%",
        textAlign: "left",
        "&.MuiSnackbar-anchorOriginTopRight": { top: "37.5%", right: "0.5%" },
      }}
    >
      <Alert
        className="intelligent-profile-notificattion-alert"
        severity="info"
        onClose={handleCloseSnackbar}
      >
        {translation.notification}
      </Alert>
    </Snackbar>
  );
}
